const Avis = ({data,key}) => {
 // console.log({data})
  return (
    <>
      <p className="body bold500 grey500 my-0" >
        {data?.rating}{" "}
        <img src="/images/star-02.svg" className="ml-4" alt="star icon" />
      </p>
      <p className="legend grey500 bold600 mb-0 mt-8">{data?.prestation?.name}</p>
      <p className="body grey66 mb-0 mt-8">{data?.comment}</p>
      <p className="body grey500 mt-8 mb-0">{data?.user?.prenom} {data?.user?.nom?.charAt(0)}.</p>
      <p className="legend grey66 mt-0">
        {new Date(data?.created_at).toLocaleDateString("fr-FR", {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })}
      </p>

    </>
  );
};
export default Avis;
